(() => {
  if (!customElements.get('dac-restock-panel')) {
    customElements.define('dac-restock-panel', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.events = new AbortController();
        this.emailFields ||= new WeakSet();
        this.storageKey = `dac-restock-email:v1:${this.dataset.customerKey || 'guest'}`;
        const remember = event => {
          if (event.target.matches('#swym-remind-email-auth-input')) {
            if (!this.prefilling) {
              this.emailEdited = true;
              this.lastEnteredValue = event.target.value;
            }
            this.rememberEmail(event.target);
          }
        };
        this.addEventListener('input', remember, { signal: this.events.signal });
        this.addEventListener('change', remember, { signal: this.events.signal });
        this.addEventListener('focusout', remember, { signal: this.events.signal });
        this.addEventListener('click', event => {
          if (event.target.closest('#swym-remind-email-auth-button')) {
            const input = this.querySelector('#swym-remind-email-auth-input');
            if (!input || !input.value.trim() || !input.validity.valid || !this.validEmail(input.value.trim())) {
              event.preventDefault();
              event.stopImmediatePropagation();
              input?.reportValidity();
              return;
            }
            this.rememberEmail(input);
          }
        }, { capture: true, signal: this.events.signal });
        this.observer = new MutationObserver(() => this.enhance());
        this.observer.observe(this, { childList: true, subtree: true });
        this.enhance();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.events?.abort(); }
      validEmail(value) { return value.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); }
      readEmail() {
        try {
          const record = JSON.parse(localStorage.getItem(this.storageKey) || 'null');
          if (record && this.validEmail(record.email || '') && record.expires > Date.now()) return record.email;
          if (record) localStorage.removeItem(this.storageKey);
        } catch (_) { /* Storage is optional; signup still works without it. */ }
        return '';
      }
      rememberEmail(input) {
        const email = input.value.trim();
        try {
          if (this.validEmail(email)) {
            localStorage.setItem(this.storageKey, JSON.stringify({ email, expires: Date.now() + 365 * 86400000 }));
          } else {
            localStorage.removeItem(this.storageKey);
          }
        } catch (_) { /* Private browsing and full storage must not block the form. */ }
      }
      prepareEmail() {
        const input = this.querySelector('#swym-remind-email-auth-input');
        if (!input || this.emailFields.has(input)) return;
        this.emailFields.add(input);
        input.autocomplete = 'email';
        input.required = true;
        input.inputMode = 'email';
        input.setAttribute('autocapitalize', 'none');
        input.spellcheck = false;
        input.placeholder = 'you@example.com';
        input.setAttribute('aria-label', this.dataset.emailLabel);
        const field = document.createElement('div');
        field.className = 'dac-restock-email-field';
        const label = document.createElement('label');
        label.htmlFor = input.id;
        label.textContent = this.dataset.emailLabel;
        input.before(field);
        field.append(label, input);
        if (this.emailEdited) {
          input.value = this.lastEnteredValue;
          return;
        }
        const saved = this.readEmail();
        const fallback = saved || this.dataset.customerEmail || '';
        if ((saved || !input.value) && input !== document.activeElement && this.validEmail(fallback)) {
          input.value = fallback;
          // Keep the provider's own input listeners in sync without submitting.
          this.prefilling = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          this.prefilling = false;
        }
      }
      enhance() {
        const header = this.querySelector('#swym-reminder-email-header');
        const isEmail = header && header.style.display !== 'none';
        const success = isEmail && this.querySelector('#swym-remind-me-subscribed-success .swym-success-msg');
        this.classList.toggle('dac-restock-email-success', Boolean(success));
        if (!isEmail) return;
        this.prepareEmail();
        const title = header.querySelector('.swym-title h2');
        const description = header.querySelector('.swym-remind-description');
        if (title && title.textContent !== this.dataset.signupTitle) title.textContent = this.dataset.signupTitle;
        if (description && description.textContent !== this.dataset.signupBody) description.textContent = this.dataset.signupBody;
        if (description) description.removeAttribute('aria-label');
        if (!success) return;
        if (success.querySelector('.dac-restock-success-title')?.textContent !== this.dataset.successTitle ||
            success.querySelector('.dac-restock-success-body')?.textContent !== this.dataset.successBody) {
          const heading = document.createElement('strong');
          heading.className = 'dac-restock-success-title';
          heading.textContent = this.dataset.successTitle;
          const body = document.createElement('span');
          body.className = 'dac-restock-success-body';
          body.textContent = this.dataset.successBody;
          success.replaceChildren(heading, body);
        }
        const again = this.querySelector('#remind-me-subscribe-btn');
        if (again && again.textContent !== this.dataset.anotherEmail) again.textContent = this.dataset.anotherEmail;
      }
    });
  }
})();
